import React from 'react';

type Props = {
  className?: string;
  isUncontrolledComponent?: boolean;
  onBlur?: (value: string) => void;
  onChange?: (value: string) => void;
  type?: 'string' | 'number';
  value?: any;
};

class Input extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  get dynamicProps() {
    const { isUncontrolledComponent, value } = this.props;
    if (isUncontrolledComponent) {
      return {
        defaultValue: value,
      };
    }
    return { value };
  }
  onChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  }
  render() {
    return (
      <div>
        <input
          type={this.props.type || 'string'}
          className="input"
          onChange={this.onChange}
          {...this.dynamicProps}
        />
      </div>
    );
  }
}

export default Input;
